import { queryOptions, useQuery } from "@tanstack/react-query"
import { apiFetch } from "../utils/apiFetch"

export type TUser = {
  user: {
    email: string
    name: string
    userId: string
    dateCreated: string
    dateOfLastLogin?: string
  }
  numberOfCompletedWorkouts: number
  totalWeightLifted: number
  totalWeightLiftedThisYear: number
  weekStreak: number
}

export const userQuery = () =>
  queryOptions({
    queryKey: ["User"],
    queryFn: () => apiFetch<TUser>("/v1/users"),
    staleTime: Infinity,
  })

const useUserQuery = () => {
  return useQuery(userQuery())
}

export function useCurrentUserQuery() {
  return useUserQuery()
}
